import React from 'react';
import { ListPageScaffold, ListPageMain } from '../../components/common/list-page';
import InventoryTransfer from '../../components/inventory/InventoryTransfer';

const InventoryTransferPage: React.FC = () => {
  return (
    <ListPageScaffold>
      <ListPageMain sectionGap={1}>
        <InventoryTransfer />
      </ListPageMain>
    </ListPageScaffold>
  );
};

export default InventoryTransferPage;
